/**
 * AudioExporter — shared audio format & encoding module for Timbrica
 * Depends on: FFmpegProcessor (ffmpeg-processor.min.js)
 *
 * Usage:
 *   AudioExporter.renderSelect({ id: 'fmt', selected: 'mp3' })
 *   AudioExporter.renderButtons({ selected: 'mp3', btnClass: 'my-btn' })
 *   var blob = await AudioExporter.encode(wavBlob, 'ogg', 128);
 *   AudioExporter.download(blob, 'file.ogg');
 */
(function(){'use strict';

var FORMATS = [
    { id: 'mp3',  label: 'MP3',  lossless: false },
    { id: 'wav',  label: 'WAV',  lossless: true },
    { id: 'ogg',  label: 'OGG',  lossless: false },
    { id: 'flac', label: 'FLAC', lossless: true },
    { id: 'm4a',  label: 'M4A',  lossless: false },
    { id: 'opus', label: 'OPUS', lossless: false },
    { id: 'aac',  label: 'AAC',  lossless: false },
    { id: 'm4r',  label: 'M4R',  lossless: false }
];

var MAP = {};
FORMATS.forEach(function(f){ MAP[f.id] = f; });

window.AudioExporter = {
    FORMATS: FORMATS,

    getFormat: function(id) { return MAP[id] || null; },

    isLossless: function(fmt) {
        var f = MAP[fmt];
        return f ? f.lossless : false;
    },

    /**
     * Encode WAV blob to target format via FFmpegProcessor
     * @param {Blob|File} wavBlob - input audio (WAV recommended)
     * @param {string} format - target format id
     * @param {number} [bitrate=128] - bitrate in kbps (lossy only)
     * @param {string} [outputName] - output filename
     * @returns {Promise<Blob>}
     */
    encode: async function(wavBlob, format, bitrate, outputName) {
        if (format === 'wav') return wavBlob;
        if (typeof FFmpegProcessor === 'undefined') throw new Error('FFmpegProcessor not loaded');
        var ok = await FFmpegProcessor.init();
        if (!ok) throw new Error('FFmpeg init failed');
        var args = FFmpegProcessor.getCodecArgs(format, bitrate || 128);
        var name = outputName || ('output.' + format);
        var result = await FFmpegProcessor.process(wavBlob, args, name, 'input.wav');
        return result.blob;
    },

    /**
     * Render format <select> HTML
     * @param {Object} [opts] - { id, className, selected, exclude }
     * @returns {string} HTML
     */
    renderSelect: function(opts) {
        opts = opts || {};
        var selected = opts.selected || 'mp3';
        var id = opts.id || '';
        var cls = opts.className || '';
        var exclude = opts.exclude || [];
        var html = '<select' + (id ? ' id="' + id + '"' : '') + (cls ? ' class="' + cls + '"' : '') + '>';
        FORMATS.forEach(function(f) {
            if (exclude.indexOf(f.id) !== -1) return;
            html += '<option value="' + f.id + '"' + (f.id === selected ? ' selected' : '') + '>' + f.label + '</option>';
        });
        html += '</select>';
        return html;
    },

    /**
     * Render format buttons HTML
     * @param {Object} [opts] - { selected, btnClass, activeClass, exclude }
     * @returns {string} HTML
     */
    renderButtons: function(opts) {
        opts = opts || {};
        var selected = opts.selected || 'mp3';
        var cls = opts.btnClass || 'fmt-btn';
        var activeCls = opts.activeClass || 'active';
        var exclude = opts.exclude || [];
        return FORMATS.filter(function(f) {
            return exclude.indexOf(f.id) === -1;
        }).map(function(f) {
            return '<button type="button" class="' + cls + (f.id === selected ? ' ' + activeCls : '') + '" data-fmt="' + f.id + '">' + f.label + '</button>';
        }).join('');
    },

    /** Download a blob as file */
    download: function(blob, filename) {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function(){ document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 100);
    }
};
})();
